import { render, staticRenderFns } from "./Actstatistics.vue?vue&type=template&id=650bd4cd&scoped=true"
import script from "./Actstatistics.vue?vue&type=script&lang=js"
export * from "./Actstatistics.vue?vue&type=script&lang=js"
import style0 from "./Actstatistics.vue?vue&type=style&index=0&id=650bd4cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650bd4cd",
  null
  
)

export default component.exports